export enum HttpMethod {
  GET = "get",
  PUT = "put",
  POST = "post",
  PATCH = "patch",
  DELETE = "delete",
  OPTIONS = "options",
  HEAD = "head",
  TRACE = "trace",
}
